import * as css from './SuspendedScreen.css';
import {updateDesignEmail, updateEmailStatus} from '../../../redux/branding/brandingActions';
import {useEffect} from 'react';
import {useContext} from 'react';
import {BrandingContext} from '../context/BrandingContext';
import EmailImage from '../EmailImage';
import {useSelector} from 'react-redux';
import SuspendedDealEditor from '../suspendedDealEditor/SuspendedDealEditor';
import ModeBtn from '../../../component/modeBtn/ModeBtn';
import EmailSubjectTextEditor, {removeTagsFromText} from '../emailSubjectTextEditor/EmailSubjectTextEditor';
import ImageHeader from '../imageHeader/ImageHeader';
import {useBrandingParams} from '../../../hooks/useBrandingParams';

function SuspendedScreen() {
    const {textEditor: {setCurrentEditorName}} = useContext(BrandingContext);
    const {currentLang,data,getBrandingData} = useSelector(s => ({
        currentLang:s.branding.currentLang,
        data:s.branding.data,
        getBrandingData:s.branding.getBrandingData
    }));
    const {messageType} = useBrandingParams();
    const emailSuspended = data?.[currentLang]?.emailSuspended;
    const {emailContent} = data?.[currentLang]?.[messageType]??{};

    const dependencies=[currentLang,getBrandingData[`${currentLang}XHR`]];

    useEffect(() => {
        setCurrentEditorName('emailContent');
    }, []);

    const updateStatus = async () => {
        await  updateEmailStatus('emailSuspended', emailSuspended===1?0:1, 'orderConfirmation');
    };

    const saveText =(content)=>{
        const smsContent = removeTagsFromText(content.replace(/<\/p><p>/g, '\n'));
        updateDesignEmail(messageType, {emailContent:content, smsContent:smsContent});
    };
   
    return (   
        <css.container data-cy="SuspendedScreen">
            <css.title>
                <ModeBtn className={'small'} status={emailSuspended} click={updateStatus}/>
            </css.title>
            <EmailSubjectTextEditor name={'emailSubject'} dependencies={dependencies}/>
            <ImageHeader text={'suspendedImageText'}/>
            <EmailImage name='suspendedImage'/>
            <SuspendedDealEditor defaultText={emailContent} name={'emailSuspendedContent'} dependencies={dependencies} onSave={(content)=>{saveText(content);}}  lang={currentLang}/>
        </css.container>
    );
}

export default SuspendedScreen;
